import mitt, { type Emitter } from 'mitt'
import type { InjectionKey } from 'vue'

// LEGACY: only two events cross the bus during the transition.
// Removed together with the last legacy emitter when views are migrated.
export interface BusEvents {
  reload_ticket_data: undefined
  // ADA-4345: "the overpayments world changed" — travels BOTH directions across the stacks,
  // because neither cache mechanism reaches the other side. New → bridge: a refund requested in
  // the new stack tells the bridge to recount the Vuex navigation badge (query invalidation
  // cannot reach Vuex). Legacy → new (#63): the legacy profile page's PATCH is a raw fetch into
  // Vuex, invisible to TanStack Query, so the bridge listener also invalidates the queries
  // derived from customer--users. Dies with the navigation + profile migrations.
  reload_overpayments: undefined
  [key: string | symbol]: unknown
}

export const eventBus = mitt<BusEvents>()

// New-code access path (inject) — legacy Options API components keep using
// this.$event_bus (globalProperties, wired in main.ts).
export const $eventBusKey: InjectionKey<Emitter<BusEvents>> = Symbol('event_bus')

declare module 'vue' {
  interface ComponentCustomProperties {
    $event_bus: Emitter<BusEvents>
  }
}
